import { useEffect, useState } from "react";
import FilterIcon from "../../assets/images/icons/FilterIcon";
import { ReactComponent as FolderIcon } from "../../assets/images/icons/FolderIcon.svg";
import ToolTipComponent from "./ToolTipComponent";
import RightContextMenuWrapper from "./RightContextMenuWrapper";
import { ReactComponent as FileIcon_docx } from "../../assets/images/icons/FileIcon_docx.svg";
import Button from "./DefaultButton";
import MotionSearchBox from "./MotionSearchBox";
import DocumentIcon from "../../utils/utilityFunctions/iconUtility";
import { ReactComponent as ShareIcon } from "../../assets/images/icons/shareIcon.svg";
import moment from "moment";

const FileExplorer = ({
  tablename = "",
  data = [],
  actionField = null,
  disableSearchIcon = false,
  handleBoxClick = () => {},
  documentContextMenu = [],
  outDocumentContextMenu = [],
  handlePaste,
  setDataMove,
  showPasteButton,
  dataMove = {},
  breadcrumpList = [],
  noDataFound = "No data found",
  internalNavBar = false,
}) => {
  const [isSearchActive, setIsSearchActive] = useState(null);

  const [searchText, setSearchText] = useState("");

  // To hide the paste button when the "dataMove" is empty.
  const [hideItems, setHideItems] = useState([]);

  const handleLeftClick = (boxData) => {
    handleBoxClick(boxData);
  };

  const handleHideFromContext = (fileData) => {
    if (fileData?.type?.toLowerCase() === "table" || fileData?.type?.toLowerCase() === "folder") {
      setHideItems(["paste", "download"]);
    } else {
      setHideItems(["paste"]);
    }
  };

  const fileFolderToolTipHtml = (folderData) => {
    return (
      <div className="flex flex-col gap-1">
        <span className="text-[10px] font-light text-[#383838B2]">
          <span className="font-normal">Name: </span>
          {folderData?.display_name}
        </span>
        <span className="text-[10px] font-light text-[#383838B2]">
          <span className="font-normal">Type: </span>
          {folderData?.mimetype}
        </span>
        <span className="text-[10px] font-light text-[#383838B2]">
          <span className="font-normal">Created By: </span>
          {folderData?.created_by}
        </span>
        <span className="text-[10px] font-light text-[#383838B2]">
          <span className="font-normal">Created Date: </span>
          {moment(folderData?.created_at).format("DD/MM/YYYY HH:mm")}
        </span>
      </div>
    );
  };

  useEffect(() => {
    if (!isSearchActive) {
      setIsSearchActive(false);
    }
  }, [isSearchActive]);

  useEffect(() => {
    if (dataMove?.type) {
      setHideItems();
    } else {
      setHideItems(["paste"]);
    }
  }, [dataMove]);

  return (
    <div className="flex h-full flex-col">
      {internalNavBar && internalNavBar()}
      <div className="flex justify-between p-1 items-center ">
        <div className="flex justify-center items-center">
          <h4 className="font-medium text-16 text-203C50 capitalize">{tablename}</h4>
        </div>
        <div className="flex justify-between  gap-2 me-1">
          <div className="flex items-center gap-1">
            {/* <Button
  variant="outline"
  // className="flex items-center gap-1 border border-[#D1D5DB] text-[#6B7280] px-3 py-1 rounded-md hover:bg-gray-100"
  // onClick={handleShare}
>
  <ShareIcon className="text-sm" />
  <span className="text-sm">Shared With Me</span>
</Button> */}
            {showPasteButton && (
              <Button
                variant="action"
                isDisabled={dataMove?.dirPath?.id === breadcrumpList[breadcrumpList.length - 1]?.id}
                onClick={() => handlePaste()}
                className="bg-1D4469 text-white rounded-md px-3 py-1"
              >
                Paste
              </Button>
            )}
            {/* {actionField && actionField} */}
            {/* {!disableSearchIcon && (
              <MotionSearchBox
                isSearchActive={isSearchActive}
                setIsSearchActive={setIsSearchActive}
                searchText={searchText}
                setSearchText={setSearchText}
                placeholder={"Search..."}
              />
            )} */}

            {/* SHOWING DISABLED FILTER ICON TO MAINTAIN LAYOUT STRUCTURE */}
            {/* <div>
              <span className="cursor-not-allowed">
                <FilterIcon />
              </span>
            </div> */}
          </div>
        </div>
      </div>
      <RightContextMenuWrapper isActive={true} menuItems={outDocumentContextMenu} hideItems={hideItems}>
        <div className="bg-white border-[1px] border-gray-200 grow p-4 rounded-lg flex flex-row gap-10 justify-start items-start flex-wrap">
          <div className="flex flex-row flex-wrap gap-10">
            {data?.length > 0 &&
              data
                ?.filter((item) => item?.display_name?.includes(searchText))
                ?.map((item, index) => {
                  return (
                    <RightContextMenuWrapper
                      key={index}
                      isActive={true}
                      rowData={item}
                      menuItems={documentContextMenu}
                      hideItems={hideItems}
                      onRightClick={(item) => handleHideFromContext(item)}
                    >
                      <div
                        onClick={() => {
                          handleLeftClick(item);
                        }}
                        key={index}
                        className={`flex flex-col gap-2 item-center p-4 px-8 border-[1px] border-[#E0E0E0] rounded-md bg-gray-50 hover:bg-gray-100 ${(item?.type?.toLowerCase() === "folder" || item?.type?.toLowerCase() === "table") && "cursor-pointer"}`}
                        draggable
                        onDragStart={() =>
                          setDataMove({ action: "move", dirPath: breadcrumpList[breadcrumpList.length - 1], ...item })
                        }
                        onDrop={(e) => handlePaste(item)}
                        onDragOver={(e) => {
                          item?.type === "folder" ? e.preventDefault() : e.stopPropagation();
                        }}
                      >
                        <DocumentIcon
                          className="w-16 h-16"
                          type={item?.type}
                          fill={item?.color || item?.code || "#FACD26"}
                          filename={item?.mimetype}
                        />

                        <ToolTipComponent
                          text={fileFolderToolTipHtml(item)}
                          title={item?.display_name}
                          disable={item?.type === "folder"}
                        >
                          <p className="p-0 m-0 text-xs text-center w-16 truncate">{item?.display_name}</p>
                        </ToolTipComponent>
                      </div>
                    </RightContextMenuWrapper>
                  );
                })}
          </div>

          {data?.length === 0 && (
            <div className="w-full flex justify-center items-center">
              <p className="text-xs text-center">{noDataFound}</p>
            </div>
          )}
        </div>
      </RightContextMenuWrapper>
    </div>
  );
};

export default FileExplorer;
